import { styled } from '@mui/material'

export const DialogTitleContent = styled('div')({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
})
